import { kycDetailsWithMaids } from "../../api/kyc";
import { bankAccountDetails, siProtectData, base_Profile_Api, profile_Config_Api } from "../../api/profile";
import { fetch_Api_Details_Fail, fetch_Api_Details_Start } from "./commonAction";
import { ActionType } from "../action-type/index";
import { Dispatch } from "redux";
import { IProfileRes, IkycRes, IsiRes } from "../interface/homeInterface";
import { kycDetailsWithMAIDsReqPayload } from "../../modules/profile/Account.model";
import { useState } from "react";
const reduxRefreshTime = Number(20 * 60 * 1000);
// const [showModal, setShowModal] = useState(false as boolean);
const fetch_base_profile_Details_Success = (profile_Data,isShowModal): IProfileRes => ({
    type: ActionType.FETCH_PROFILE_DETAILS_SUCCESS,
    profile_Details: profile_Data,
    timeStamp: Date.now() + reduxRefreshTime,
    isShowModal:isShowModal,
})

export const fetch_base_profile_Details = (isShowModal) => {
    return (dispatch: Dispatch<IProfileRes>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_PROFILE_DETAILS_START));
        base_Profile_Api().then((response) => {
            if (response && response.isSuccess) {
                dispatch(fetch_base_profile_Details_Success(response.data,isShowModal));
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_PROFILE_DETAILS_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_PROFILE_DETAILS_FAIL, error.message));
        })
    }
}

export const fetch_Config_Details = () => {
    return (dispatch) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_CONFIG_DETAILS_START));
        profile_Config_Api().then((response) => {
                dispatch({
                    type: ActionType.FETCH_CONFIG_DETAILS_SUCCESS,
                    config_Details: response,
                    timeStamp: Date.now() + reduxRefreshTime,
                });
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_CONFIG_DETAILS_FAIL, error.message));
        })
    }
}

export const fetch_Si_Protect = () => {
    return (dispatch: Dispatch<IsiRes>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_SI_PROTECT_START));
        siProtectData().then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_SI_PROTECT_SUCCESS,
                    siprotect_Details: response.siProtectDetails,
                    timeStamp: Date.now() + reduxRefreshTime,
                });
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_SI_PROTECT_FAIL, response.error || response.message));
            }
        })
            .catch((error) => {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_SI_PROTECT_FAIL, error.message));
            })
    }
}
// kycdetails api
export const fetch_Kyc_Details = (payload: kycDetailsWithMAIDsReqPayload) => {
    return (dispatch: Dispatch<IkycRes>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_KYC_START));
        kycDetailsWithMaids(payload).then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_KYC_SUCCESS,
                    kyc_Details: response.kycDetails,
                    timeStamp: Date.now() + reduxRefreshTime,
                });
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_KYC_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_KYC_FAIL, error.message));
        })
    }
}
export const fetch_bank_Details = () => {
    return (dispatch) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_BANK_DETAIL_START));
        bankAccountDetails().then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_BANK_DETAIL_SUCCESS,
                    data: response.data,
                    timeStamp: Date.now() + reduxRefreshTime,
                });
            } if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_BANK_DETAIL_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_BANK_DETAIL_FAIL, error.message));
        })
    }
}